export default "__VITE_ASSET__062abbe3__"